import { corporateCMSApi } from "~/Services";
import { ModuleConfig, ModuleFields } from "~/Utils/drilldownData";
const generateFields = (
  basePath: string,
  languages: { code: string; label: string; parseField: string }[],
  sectionName: string,
  idx1: number,
  idx2: number
): ModuleFields[] => {
  return languages.flatMap((lang) => [
    {
      fieldName: `Title (${lang.code})`,
      fieldValue: `${basePath}.items[${idx1}].tabData.items[${idx2}].title`,
      parseField: lang.parseField,
      className: "col-span-6",
      type: "content",
      name: `${lang.parseField}.${basePath}.items[${idx1}].tabData.items[${idx2}].title`,
      formType: "input",
      label: `Title (${lang.code})`,
      placeholder: `Select Title ${lang.code} ${sectionName}`,
      validation:
        lang.parseField === "field_content_english"
          ? { required: `Title ${lang.code} ${sectionName} is required` }
          : undefined,
    },
    {
      fieldName: `Markup (${lang.code})`,
      fieldValue: `${basePath}.items[${idx1}].tabData.items[${idx2}].markup`,
      parseField: lang.parseField,
      className: "col-span-6",
      type: "content",
      name: `${lang.parseField}.${basePath}.items[${idx1}].tabData.items[${idx2}].markup`,
      formType: "richText",
      label: `Markup (${lang.code})`,
      placeholder: `Enter Markup ${lang.code} ${sectionName}`,
      validation:
        lang.parseField === "field_content_english"
          ? { required: `Markup ${lang.code} ${sectionName} is required` }
          : undefined,
    },
  ]);
};
const languages = [
  { code: "EN", label: "English", parseField: "field_content_english" },
  { code: "MS", label: "Malay", parseField: "field_content_malay" },
  { code: "ZH", label: "Mandarin", parseField: "field_content_mandarin" },
];
let url = `/api/page-content/all-fields?pageName=about-us/corporate-profile/our-policies`;
export let getData: { [key in ModuleConfig]: ModuleFields[] } | null = null;
const fetchProfileData = async (): Promise<{ [key in ModuleConfig]: ModuleFields[] } | null> => {
  try {
    const res = await corporateCMSApi.get(url);
    const profileData = res.data;
    const fields1 =
      profileData?.[0]?.field_content_english?.data?.items?.[0]?.tabData?.items?.map((item: any, index: number) =>
        generateFields("data", languages, item.key, 0, index)
      ) || [];
    const fields2 =
      profileData?.[0]?.field_content_english?.data?.items?.[1]?.tabData?.items?.map((item: any, index: number) =>
        generateFields("data", languages, item.key, 1, index)
      ) || [];
    return {
      malaysiaAirportsHoldingsBerhadOurPolicies: fields1 as ModuleFields[],
      subsidiariesOurPolicies: fields2 as ModuleFields[],
    };
  } catch (error) {
    return null;
  }
};
export const getOurPoliciesDrillDownData = async () => {
  if (!getData) {
    getData = await fetchProfileData();
  }
  return getData;
};

// export const getOurPoliciesDrillDownData: { [key in ModuleConfig]: ModuleFields[] } = {
//   codeOfEthicsForMalaysiaAirportsHoldingsBerhad: [
//     {
//       fieldName: "Markup (EN)",
//       fieldValue: "data.items[0].tabData.items[0].markup",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_codeOfEthicsForMalaysiaAirportsHoldingsBerhad",
//       formType: "richText",
//       label: "Body (EN)",
//       placeholder: "Enter the Code of Ethics",
//       validation: { required: "Code of Ethics is required" },
//     },
//     {
//       fieldName: "Next Page Name (EN)",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_name",
//       formType: "input",
//       label: "Next Page Name (EN)",
//       placeholder: "Enter content for Next Page Name (EN)",
//       validation: { required: "Content for Next Page Name (EN) is required" },
//     },
//     {
//       fieldName: "Next Page Link (EN)",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_link",
//       formType: "input",
//       label: "Next Page Link (EN)",
//       placeholder: "Enter content for Next Page Link (EN)",
//       validation: { required: "Content for Next Page Link (EN) is required" },
//     },

//     {
//       fieldName: "Markup (MS)",
//       fieldValue: "data.items[0].tabData.items[0].markup",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_codeOfEthicsForMalaysiaAirportsHoldingsBerhad",
//       formType: "richText",
//       label: "Body (MS)",
//       placeholder: "Enter the Code of Ethics",
//       // validation: { required: "Code of Ethics is required" },
//     },
//     {
//       fieldName: "Next Page Name (MS)",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_nextPage_name",
//       formType: "input",
//       label: "Next Page Name (MS)",
//       placeholder: "Enter content for Next Page Name (MS)",
//       // validation: { required: "Content for Next Page Name (MS) is required" },
//     },
//     {
//       fieldName: "Next Page Link (MS)",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_nextPage_link",
//       formType: "input",
//       label: "Next Page Link (MS)",
//       placeholder: "Enter content for Next Page Link (MS)",
//       // validation: { required: "Content for Next Page Link (MS) is required" },
//     },

//     {
//       fieldName: "Markup (ZH)",
//       fieldValue: "data.items[0].tabData.items[0].markup",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_codeOfEthicsForMalaysiaAirportsHoldingsBerhad",
//       formType: "richText",
//       label: "Body (ZH)",
//       placeholder: "Enter the Code of Ethics",
//       // validation: { required: "Code of Ethics is required" },
//     },
//     {
//       fieldName: "Next Page Name (ZH)",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_name",
//       formType: "input",
//       label: "Next Page Name (ZH)",
//       placeholder: "Enter content for Next Page Name (ZH)",
//       // validation: { required: "Content for Next Page Name (ZH) is required" },
//     },
//     {
//       fieldName: "Next Page Link (ZH)",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_link",
//       formType: "input",
//       label: "Next Page Link (ZH)",
//       placeholder: "Enter content for Next Page Link (ZH)",
//       // validation: { required: "Content for Next Page Link (ZH) is required" },
//     },
//   ],

//   conditionsOfUseForMalaysiaAirportsHoldingsBerhad: [
//     {
//       fieldName: "Markup (EN)",
//       fieldValue: "data.items[0].tabData.items[1].markup",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_conditionsOfUseForMalaysiaAirportsHoldingsBerhad",
//       formType: "richText",
//       label: "Body (EN)",
//       placeholder: "Enter the Conditions of Use",
//       validation: { required: "Conditions of Use is required" },
//     },
//     {
//       fieldName: "Next Page Name (EN)",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_name",
//       formType: "input",
//       label: "Next Page Name (EN)",
//       placeholder: "Enter content for Next Page Name (EN)",
//       validation: { required: "Content for Next Page Name (EN) is required" },
//     },
//     {
//       fieldName: "Next Page Link (EN)",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_link",
//       formType: "input",
//       label: "Next Page Link (EN)",
//       placeholder: "Enter content for Next Page Link (EN)",
//       validation: { required: "Content for Next Page Link (EN) is required" },
//     },

//     {
//       fieldName: "Markup (MS)",
//       fieldValue: "data.items[0].tabData.items[1].markup",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_conditionsOfUseForMalaysiaAirportsHoldingsBerhad",
//       formType: "richText",
//       label: "Body (MS)",
//       placeholder: "Enter the Conditions of Use",
//       // validation: { required: "Conditions of Use is required" },
//     },
//     {
//       fieldName: "Next Page Name (MS)",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_nextPage_name",
//       formType: "input",
//       label: "Next Page Name (MS)",
//       placeholder: "Enter content for Next Page Name (MS)",
//       // validation: { required: "Content for Next Page Name (MS) is required" },
//     },
//     {
//       fieldName: "Next Page Link (MS)",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_nextPage_link",
//       formType: "input",
//       label: "Next Page Link (MS)",
//       placeholder: "Enter content for Next Page Link (MS)",
//       // validation: { required: "Content for Next Page Link (MS) is required" },
//     },

//     {
//       fieldName: "Markup (ZH)",
//       fieldValue: "data.items[0].tabData.items[1].markup",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_conditionsOfUseForMalaysiaAirportsHoldingsBerhad",
//       formType: "richText",
//       label: "Body (ZH)",
//       placeholder: "Enter the Conditions of Use",
//       // validation: { required: "Conditions of Use is required" },
//     },
//     {
//       fieldName: "Next Page Name (ZH)",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_name",
//       formType: "input",
//       label: "Next Page Name (ZH)",
//       placeholder: "Enter content for Next Page Name (ZH)",
//       // validation: { required: "Content for Next Page Name (ZH) is required" },
//     },
//     {
//       fieldName: "Next Page Link (ZH)",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_link",
//       formType: "input",
//       label: "Next Page Link (ZH)",
//       placeholder: "Enter content for Next Page Link (ZH)",
//       // validation: { required: "Content for Next Page Link (ZH) is required" },
//     },
//   ],

//   energyPolicyForMalaysiaAirportsHoldingsBerhad: [
//     {
//       fieldName: "Markup (EN)",
//       fieldValue: "data.items[0].tabData.items[2].markup",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_energyPolicyForMalaysiaAirportsHoldingsBerhad",
//       formType: "richText",
//       label: "Body (EN)",
//       placeholder: "Enter the Energy policy",
//       validation: { required: "Energy policy is required" },
//     },
//     {
//       fieldName: "Next Page Name (EN)",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_name",
//       formType: "input",
//       label: "Next Page Name (EN)",
//       placeholder: "Enter content for Next Page Name (EN)",
//       validation: { required: "Content for Next Page Name (EN) is required" },
//     },
//     {
//       fieldName: "Next Page Link (EN)",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_link",
//       formType: "input",
//       label: "Next Page Link (EN)",
//       placeholder: "Enter content for Next Page Link (EN)",
//       validation: { required: "Content for Next Page Link (EN) is required" },
//     },

//     {
//       fieldName: "Markup (MS)",
//       fieldValue: "data.items[0].tabData.items[2].markup",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_energyPolicyForMalaysiaAirportsHoldingsBerhad",
//       formType: "richText",
//       label: "Body (MS)",
//       placeholder: "Enter the Energy policy",
//       // validation: { required: "Energy policy is required" },
//     },
//     {
//       fieldName: "Next Page Name (MS)",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_nextPage_name",
//       formType: "input",
//       label: "Next Page Name (MS)",
//       placeholder: "Enter content for Next Page Name (MS)",
//       // validation: { required: "Content for Next Page Name (MS) is required" },
//     },
//     {
//       fieldName: "Next Page Link (MS)",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_nextPage_link",
//       formType: "input",
//       label: "Next Page Link (MS)",
//       placeholder: "Enter content for Next Page Link (MS)",
//       // validation: { required: "Content for Next Page Link (MS) is required" },
//     },

//     {
//       fieldName: "Markup (ZH)",
//       fieldValue: "data.items[0].tabData.items[2].markup",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_energyPolicyForMalaysiaAirportsHoldingsBerhad",
//       formType: "richText",
//       label: "Body (ZH)",
//       placeholder: "Enter the Energy policy",
//       // validation: { required: "Energy policy is required" },
//     },
//     {
//       fieldName: "Next Page Name (ZH)",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_name",
//       formType: "input",
//       label: "Next Page Name (ZH)",
//       placeholder: "Enter content for Next Page Name (ZH)",
//       // validation: { required: "Content for Next Page Name (ZH) is required" },
//     },
//     {
//       fieldName: "Next Page Link (ZH)",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_link",
//       formType: "input",
//       label: "Next Page Link (ZH)",
//       placeholder: "Enter content for Next Page Link (ZH)",
//       // validation: { required: "Content for Next Page Link (ZH) is required" },
//     },
//   ],

//   environmentalManagementPolicyForMalaysiaAirportsHoldingsBerhad: [
//     {
//       fieldName: "Markup (EN)",
//       fieldValue: "data.items[0].tabData.items[3].markup",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_environmentalManagementPolicyForMalaysiaAirportsHoldingsBerhad",
//       formType: "richText",
//       label: "Body (EN)",
//       placeholder: "Enter the Environmental Management policy",
//       validation: { required: "Environmental Management policy is required" },
//     },
//     {
//       fieldName: "Next Page Name (EN)",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_name",
//       formType: "input",
//       label: "Next Page Name (EN)",
//       placeholder: "Enter content for Next Page Name (EN)",
//       validation: { required: "Content for Next Page Name (EN) is required" },
//     },
//     {
//       fieldName: "Next Page Link (EN)",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_link",
//       formType: "input",
//       label: "Next Page Link (EN)",
//       placeholder: "Enter content for Next Page Link (EN)",
//       validation: { required: "Content for Next Page Link (EN) is required" },
//     },

//     {
//       fieldName: "Markup (MS)",
//       fieldValue: "data.items[0].tabData.items[3].markup",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_environmentalManagementPolicyForMalaysiaAirportsHoldingsBerhad",
//       formType: "richText",
//       label: "Body (MS)",
//       placeholder: "Enter the Environmental Management policy",
//       // validation: { required: "Environmental Management policy is required" },
//     },
//     {
//       fieldName: "Next Page Name (MS)",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_nextPage_name",
//       formType: "input",
//       label: "Next Page Name (MS)",
//       placeholder: "Enter content for Next Page Name (MS)",
//       // validation: { required: "Content for Next Page Name (MS) is required" },
//     },
//     {
//       fieldName: "Next Page Link (MS)",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_nextPage_link",
//       formType: "input",
//       label: "Next Page Link (MS)",
//       placeholder: "Enter content for Next Page Link (MS)",
//       // validation: { required: "Content for Next Page Link (MS) is required" },
//     },

//     {
//       fieldName: "Markup (ZH)",
//       fieldValue: "data.items[0].tabData.items[3].markup",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_environmentalManagementPolicyForMalaysiaAirportsHoldingsBerhad",
//       formType: "richText",
//       label: "Body (ZH)",
//       placeholder: "Enter the Environmental Management policy",
//       // validation: { required: "Environmental Management policy is required" },
//     },
//     {
//       fieldName: "Next Page Name (ZH)",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_name",
//       formType: "input",
//       label: "Next Page Name (ZH)",
//       placeholder: "Enter content for Next Page Name (ZH)",
//       // validation: { required: "Content for Next Page Name (ZH) is required" },
//     },
//     {
//       fieldName: "Next Page Link (ZH)",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_link",
//       formType: "input",
//       label: "Next Page Link (ZH)",
//       placeholder: "Enter content for Next Page Link (ZH)",
//       // validation: { required: "Content for Next Page Link (ZH) is required" },
//     },
//   ],

//   fraudPolicyForMalaysiaAirportsHoldingsBerhad: [
//     {
//       fieldName: "Markup (EN)",
//       fieldValue: "data.items[0].tabData.items[4].markup",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_fraudPolicyForMalaysiaAirportsHoldingsBerhad",
//       formType: "richText",
//       label: "Body (EN)",
//       placeholder: "Enter the Fraud Policy",
//       validation: { required: "Fraud Policy is required" },
//     },
//     {
//       fieldName: "Next Page Name (EN)",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_name",
//       formType: "input",
//       label: "Next Page Name (EN)",
//       placeholder: "Enter content for Next Page Name (EN)",
//       validation: { required: "Content for Next Page Name (EN) is required" },
//     },
//     {
//       fieldName: "Next Page Link (EN)",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_link",
//       formType: "input",
//       label: "Next Page Link (EN)",
//       placeholder: "Enter content for Next Page Link (EN)",
//       validation: { required: "Content for Next Page Link (EN) is required" },
//     },

//     {
//       fieldName: "Markup (MS)",
//       fieldValue: "data.items[0].tabData.items[4].markup",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_fraudPolicyForMalaysiaAirportsHoldingsBerhad",
//       formType: "richText",
//       label: "Body (MS)",
//       placeholder: "Enter the Fraud Policy",
//       // validation: { required: "Fraud Policy is required" },
//     },
//     {
//       fieldName: "Next Page Name (MS)",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_nextPage_name",
//       formType: "input",
//       label: "Next Page Name (MS)",
//       placeholder: "Enter content for Next Page Name (MS)",
//       // validation: { required: "Content for Next Page Name (MS) is required" },
//     },
//     {
//       fieldName: "Next Page Link (MS)",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_nextPage_link",
//       formType: "input",
//       label: "Next Page Link (MS)",
//       placeholder: "Enter content for Next Page Link (MS)",
//       // validation: { required: "Content for Next Page Link (MS) is required" },
//     },

//     {
//       fieldName: "Markup (ZH)",
//       fieldValue: "data.items[0].tabData.items[4].markup",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_fraudPolicyForMalaysiaAirportsHoldingsBerhad",
//       formType: "richText",
//       label: "Body (ZH)",
//       placeholder: "Enter the Fraud Policy",
//       // validation: { required: "Fraud Policy is required" },
//     },
//     {
//       fieldName: "Next Page Name (ZH)",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_name",
//       formType: "input",
//       label: "Next Page Name (ZH)",
//       placeholder: "Enter content for Next Page Name (ZH)",
//       // validation: { required: "Content for Next Page Name (ZH) is required" },
//     },
//     {
//       fieldName: "Next Page Link (ZH)",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_link",
//       formType: "input",
//       label: "Next Page Link (ZH)",
//       placeholder: "Enter content for Next Page Link (ZH)",
//       // validation: { required: "Content for Next Page Link (ZH) is required" },
//     },
//   ],

//   giftPolicyForMalaysiaAirportsHoldingsBerhad: [
//     {
//       fieldName: "Markup (EN)",
//       fieldValue: "data.items[0].tabData.items[5].markup",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_giftPolicyForMalaysiaAirportsHoldingsBerhad",
//       formType: "richText",
//       label: "Body (EN)",
//       placeholder: "Enter the Gift Policy",
//       validation: { required: "Gift Policy is required" },
//     },
//     {
//       fieldName: "Next Page Name (EN)",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_name",
//       formType: "input",
//       label: "Next Page Name (EN)",
//       placeholder: "Enter content for Next Page Name (EN)",
//       validation: { required: "Content for Next Page Name (EN) is required" },
//     },
//     {
//       fieldName: "Next Page Link (EN)",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_link",
//       formType: "input",
//       label: "Next Page Link (EN)",
//       placeholder: "Enter content for Next Page Link (EN)",
//       validation: { required: "Content for Next Page Link (EN) is required" },
//     },

//     {
//       fieldName: "Markup (MS)",
//       fieldValue: "data.items[0].tabData.items[5].markup",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_giftPolicyForMalaysiaAirportsHoldingsBerhad",
//       formType: "richText",
//       label: "Body (MS)",
//       placeholder: "Enter the Gift Policy",
//       // validation: { required: "Gift Policy is required" },
//     },
//     {
//       fieldName: "Next Page Name (MS)",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_nextPage_name",
//       formType: "input",
//       label: "Next Page Name (MS)",
//       placeholder: "Enter content for Next Page Name (MS)",
//       // validation: { required: "Content for Next Page Name (MS) is required" },
//     },
//     {
//       fieldName: "Next Page Link (MS)",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_nextPage_link",
//       formType: "input",
//       label: "Next Page Link (MS)",
//       placeholder: "Enter content for Next Page Link (MS)",
//       // validation: { required: "Content for Next Page Link (MS) is required" },
//     },

//     {
//       fieldName: "Markup (ZH)",
//       fieldValue: "data.items[0].tabData.items[5].markup",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_giftPolicyForMalaysiaAirportsHoldingsBerhad",
//       formType: "richText",
//       label: "Body (ZH)",
//       placeholder: "Enter the Gift Policy",
//       // validation: { required: "Gift Policy is required" },
//     },
//     {
//       fieldName: "Next Page Name (ZH)",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_name",
//       formType: "input",
//       label: "Next Page Name (ZH)",
//       placeholder: "Enter content for Next Page Name (ZH)",
//       // validation: { required: "Content for Next Page Name (ZH) is required" },
//     },
//     {
//       fieldName: "Next Page Link (ZH)",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_link",
//       formType: "input",
//       label: "Next Page Link (ZH)",
//       placeholder: "Enter content for Next Page Link (ZH)",
//       // validation: { required: "Content for Next Page Link (ZH) is required" },
//     },
//   ],

//   noSmokingPolicyForMalaysiaAirportsHoldingsBerhad: [
//     {
//       fieldName: "Markup (EN)",
//       fieldValue: "data.items[0].tabData.items[6].markup",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_noSmokingPolicyForMalaysiaAirportsHoldingsBerhad",
//       formType: "richText",
//       label: "Body (EN)",
//       placeholder: "Enter the No Smoking Policy",
//       validation: { required: "No Smoking Policy is required" },
//     },
//     {
//       fieldName: "Next Page Name (EN)",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_name",
//       formType: "input",
//       label: "Next Page Name (EN)",
//       placeholder: "Enter content for Next Page Name (EN)",
//       validation: { required: "Content for Next Page Name (EN) is required" },
//     },
//     {
//       fieldName: "Next Page Link (EN)",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_link",
//       formType: "input",
//       label: "Next Page Link (EN)",
//       placeholder: "Enter content for Next Page Link (EN)",
//       validation: { required: "Content for Next Page Link (EN) is required" },
//     },

//     {
//       fieldName: "Markup (MS)",
//       fieldValue: "data.items[0].tabData.items[6].markup",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_noSmokingPolicyForMalaysiaAirportsHoldingsBerhad",
//       formType: "richText",
//       label: "Body (MS)",
//       placeholder: "Enter the No Smoking Policy",
//       // validation: { required: "No Smoking Policy is required" },
//     },
//     {
//       fieldName: "Next Page Name (MS)",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_nextPage_name",
//       formType: "input",
//       label: "Next Page Name (MS)",
//       placeholder: "Enter content for Next Page Name (MS)",
//       // validation: { required: "Content for Next Page Name (MS) is required" },
//     },
//     {
//       fieldName: "Next Page Link (MS)",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_nextPage_link",
//       formType: "input",
//       label: "Next Page Link (MS)",
//       placeholder: "Enter content for Next Page Link (MS)",
//       // validation: { required: "Content for Next Page Link (MS) is required" },
//     },

//     {
//       fieldName: "Markup (ZH)",
//       fieldValue: "data.items[0].tabData.items[6].markup",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_noSmokingPolicyForMalaysiaAirportsHoldingsBerhad",
//       formType: "richText",
//       label: "Body (ZH)",
//       placeholder: "Enter the No Smoking Policy",
//       // validation: { required: "No Smoking Policy is required" },
//     },
//     {
//       fieldName: "Next Page Name (ZH)",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_name",
//       formType: "input",
//       label: "Next Page Name (ZH)",
//       placeholder: "Enter content for Next Page Name (ZH)",
//       // validation: { required: "Content for Next Page Name (ZH) is required" },
//     },
//     {
//       fieldName: "Next Page Link (ZH)",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_link",
//       formType: "input",
//       label: "Next Page Link (ZH)",
//       placeholder: "Enter content for Next Page Link (ZH)",
//       // validation: { required: "Content for Next Page Link (ZH) is required" },
//     },
//   ],

//   policyInWorkplaceForMalaysiaAirportsHoldingsBerhad: [
//     {
//       fieldName: "Markup (EN)",
//       fieldValue: "data.items[0].tabData.items[7].markup",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_policyInWorkplaceForMalaysiaAirportsHoldingsBerhad",
//       formType: "richText",
//       label: "Body (EN)",
//       placeholder: "Enter the Policy in Workplace",
//       validation: { required: "Policy in Workplace is required" },
//     },
//     {
//       fieldName: "Next Page Name (EN)",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_name",
//       formType: "input",
//       label: "Next Page Name (EN)",
//       placeholder: "Enter content for Next Page Name (EN)",
//       validation: { required: "Content for Next Page Name (EN) is required" },
//     },
//     {
//       fieldName: "Next Page Link (EN)",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_link",
//       formType: "input",
//       label: "Next Page Link (EN)",
//       placeholder: "Enter content for Next Page Link (EN)",
//       validation: { required: "Content for Next Page Link (EN) is required" },
//     },

//     {
//       fieldName: "Markup (MS)",
//       fieldValue: "data.items[0].tabData.items[7].markup",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_policyInWorkplaceForMalaysiaAirportsHoldingsBerhad",
//       formType: "richText",
//       label: "Body (MS)",
//       placeholder: "Enter the Policy in Workplace",
//       // validation: { required: "Policy in Workplace is required" },
//     },
//     {
//       fieldName: "Next Page Name (MS)",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_nextPage_name",
//       formType: "input",
//       label: "Next Page Name (MS)",
//       placeholder: "Enter content for Next Page Name (MS)",
//       // validation: { required: "Content for Next Page Name (MS) is required" },
//     },
//     {
//       fieldName: "Next Page Link (MS)",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_nextPage_link",
//       formType: "input",
//       label: "Next Page Link (MS)",
//       placeholder: "Enter content for Next Page Link (MS)",
//       // validation: { required: "Content for Next Page Link (MS) is required" },
//     },

//     {
//       fieldName: "Markup (ZH)",
//       fieldValue: "data.items[0].tabData.items[7].markup",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_policyInWorkplaceForMalaysiaAirportsHoldingsBerhad",
//       formType: "richText",
//       label: "Body (ZH)",
//       placeholder: "Enter the Policy in Workplace",
//       // validation: { required: "Policy in Workplace is required" },
//     },
//     {
//       fieldName: "Next Page Name (ZH)",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_name",
//       formType: "input",
//       label: "Next Page Name (ZH)",
//       placeholder: "Enter content for Next Page Name (ZH)",
//       // validation: { required: "Content for Next Page Name (ZH) is required" },
//     },
//     {
//       fieldName: "Next Page Link (ZH)",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_link",
//       formType: "input",
//       label: "Next Page Link (ZH)",
//       placeholder: "Enter content for Next Page Link (ZH)",
//       // validation: { required: "Content for Next Page Link (ZH) is required" },
//     },
//   ],

//   privacyNoticeForMalaysiaAirportsHoldingsBerhad: [
//     {
//       fieldName: "Markup (EN)",
//       fieldValue: "data.items[0].tabData.items[8].markup",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_privacyNoticeForMalaysiaAirportsHoldingsBerhad",
//       formType: "richText",
//       label: "Body (EN)",
//       placeholder: "Enter the Privacy Notice",
//       validation: { required: "Privacy Notice is required" },
//     },
//     {
//       fieldName: "Next Page Name (EN)",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_name",
//       formType: "input",
//       label: "Next Page Name (EN)",
//       placeholder: "Enter content for Next Page Name (EN)",
//       validation: { required: "Content for Next Page Name (EN) is required" },
//     },
//     {
//       fieldName: "Next Page Link (EN)",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_link",
//       formType: "input",
//       label: "Next Page Link (EN)",
//       placeholder: "Enter content for Next Page Link (EN)",
//       validation: { required: "Content for Next Page Link (EN) is required" },
//     },

//     {
//       fieldName: "Markup (MS)",
//       fieldValue: "data.items[0].tabData.items[8].markup",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_privacyNoticeForMalaysiaAirportsHoldingsBerhad",
//       formType: "richText",
//       label: "Body (MS)",
//       placeholder: "Enter the Privacy Notice",
//       // validation: { required: "Privacy Notice is required" },
//     },
//     {
//       fieldName: "Next Page Name (MS)",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_nextPage_name",
//       formType: "input",
//       label: "Next Page Name (MS)",
//       placeholder: "Enter content for Next Page Name (MS)",
//       // validation: { required: "Content for Next Page Name (MS) is required" },
//     },
//     {
//       fieldName: "Next Page Link (MS)",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_nextPage_link",
//       formType: "input",
//       label: "Next Page Link (MS)",
//       placeholder: "Enter content for Next Page Link (MS)",
//       // validation: { required: "Content for Next Page Link (MS) is required" },
//     },

//     {
//       fieldName: "Markup (ZH)",
//       fieldValue: "data.items[0].tabData.items[8].markup",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_privacyNoticeForMalaysiaAirportsHoldingsBerhad",
//       formType: "richText",
//       label: "Body (ZH)",
//       placeholder: "Enter the Privacy Notice",
//       // validation: { required: "Privacy Notice is required" },
//     },
//     {
//       fieldName: "Next Page Name (ZH)",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_name",
//       formType: "input",
//       label: "Next Page Name (ZH)",
//       placeholder: "Enter content for Next Page Name (ZH)",
//       // validation: { required: "Content for Next Page Name (ZH) is required" },
//     },
//     {
//       fieldName: "Next Page Link (ZH)",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_link",
//       formType: "input",
//       label: "Next Page Link (ZH)",
//       placeholder: "Enter content for Next Page Link (ZH)",
//       // validation: { required: "Content for Next Page Link (ZH) is required" },
//     },
//   ],

//   privacyNoticeForShareholdersForMalaysiaAirportsHoldingsBerhad: [
//     {
//       fieldName: "Markup (EN)",
//       fieldValue: "data.items[0].tabData.items[9].markup",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_privacyNoticeForShareholdersForMalaysiaAirportsHoldingsBerhad",
//       formType: "richText",
//       label: "Body (EN)",
//       placeholder: "Enter the Privacy Notice for Shareholders",
//       validation: { required: "Privacy Notice for Shareholders is required" },
//     },
//     {
//       fieldName: "Next Page Name (EN)",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_name",
//       formType: "input",
//       label: "Next Page Name (EN)",
//       placeholder: "Enter content for Next Page Name (EN)",
//       validation: { required: "Content for Next Page Name (EN) is required" },
//     },
//     {
//       fieldName: "Next Page Link (EN)",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_link",
//       formType: "input",
//       label: "Next Page Link (EN)",
//       placeholder: "Enter content for Next Page Link (EN)",
//       validation: { required: "Content for Next Page Link (EN) is required" },
//     },

//     {
//       fieldName: "Markup (MS)",
//       fieldValue: "data.items[0].tabData.items[9].markup",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_privacyNoticeForShareholdersForMalaysiaAirportsHoldingsBerhad",
//       formType: "richText",
//       label: "Body (MS)",
//       placeholder: "Enter the Privacy Notice for Shareholders",
//       // validation: { required: "Privacy Notice for Shareholders is required" },
//     },
//     {
//       fieldName: "Next Page Name (MS)",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_nextPage_name",
//       formType: "input",
//       label: "Next Page Name (MS)",
//       placeholder: "Enter content for Next Page Name (MS)",
//       // validation: { required: "Content for Next Page Name (MS) is required" },
//     },
//     {
//       fieldName: "Next Page Link (MS)",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_nextPage_link",
//       formType: "input",
//       label: "Next Page Link (MS)",
//       placeholder: "Enter content for Next Page Link (MS)",
//       // validation: { required: "Content for Next Page Link (MS) is required" },
//     },

//     {
//       fieldName: "Markup (ZH)",
//       fieldValue: "data.items[0].tabData.items[9].markup",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_privacyNoticeForShareholdersForMalaysiaAirportsHoldingsBerhad",
//       formType: "richText",
//       label: "Body (ZH)",
//       placeholder: "Enter the Privacy Notice for Shareholders",
//       // validation: { required: "Privacy Notice for Shareholders is required" },
//     },
//     {
//       fieldName: "Next Page Name (ZH)",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_name",
//       formType: "input",
//       label: "Next Page Name (ZH)",
//       placeholder: "Enter content for Next Page Name (ZH)",
//       // validation: { required: "Content for Next Page Name (ZH) is required" },
//     },
//     {
//       fieldName: "Next Page Link (ZH)",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_link",
//       formType: "input",
//       label: "Next Page Link (ZH)",
//       placeholder: "Enter content for Next Page Link (ZH)",
//       // validation: { required: "Content for Next Page Link (ZH) is required" },
//     },
//   ],

//   procurementManualForMalaysiaAirportsHoldingsBerhad: [
//     {
//       fieldName: "Markup (EN)",
//       fieldValue: "data.items[0].tabData.items[10].markup",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_procurementManualForMalaysiaAirportsHoldingsBerhad",
//       formType: "richText",
//       label: "Body (EN)",
//       placeholder: "Enter the Procurement Manual",
//       validation: { required: "Procurement Manual is required" },
//     },
//     {
//       fieldName: "Next Page Name (EN)",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_name",
//       formType: "input",
//       label: "Next Page Name (EN)",
//       placeholder: "Enter content for Next Page Name (EN)",
//       validation: { required: "Content for Next Page Name (EN) is required" },
//     },
//     {
//       fieldName: "Next Page Link (EN)",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_link",
//       formType: "input",
//       label: "Next Page Link (EN)",
//       placeholder: "Enter content for Next Page Link (EN)",
//       validation: { required: "Content for Next Page Link (EN) is required" },
//     },

//     {
//       fieldName: "Markup (MS)",
//       fieldValue: "data.items[0].tabData.items[10].markup",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_procurementManualForMalaysiaAirportsHoldingsBerhad",
//       formType: "richText",
//       label: "Body (MS)",
//       placeholder: "Enter the Procurement Manual",
//       // validation: { required: "Procurement Manual is required" },
//     },
//     {
//       fieldName: "Next Page Name (MS)",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_nextPage_name",
//       formType: "input",
//       label: "Next Page Name (MS)",
//       placeholder: "Enter content for Next Page Name (MS)",
//       // validation: { required: "Content for Next Page Name (MS) is required" },
//     },
//     {
//       fieldName: "Next Page Link (MS)",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_nextPage_link",
//       formType: "input",
//       label: "Next Page Link (MS)",
//       placeholder: "Enter content for Next Page Link (MS)",
//       // validation: { required: "Content for Next Page Link (MS) is required" },
//     },

//     {
//       fieldName: "Markup (ZH)",
//       fieldValue: "data.items[0].tabData.items[10].markup",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_procurementManualForMalaysiaAirportsHoldingsBerhad",
//       formType: "richText",
//       label: "Body (ZH)",
//       placeholder: "Enter the Procurement Manual",
//       // validation: { required: "Procurement Manual is required" },
//     },
//     {
//       fieldName: "Next Page Name (ZH)",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_name",
//       formType: "input",
//       label: "Next Page Name (ZH)",
//       placeholder: "Enter content for Next Page Name (ZH)",
//       // validation: { required: "Content for Next Page Name (ZH) is required" },
//     },
//     {
//       fieldName: "Next Page Link (ZH)",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_link",
//       formType: "input",
//       label: "Next Page Link (ZH)",
//       placeholder: "Enter content for Next Page Link (ZH)",
//       // validation: { required: "Content for Next Page Link (ZH) is required" },
//     },
//   ],

//   riskManagementPolicyStatementForMalaysiaAirportsHoldingsBerhad: [
//     {
//       fieldName: "Markup (EN)",
//       fieldValue: "data.items[0].tabData.items[11].markup",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_riskManagementPolicyStatementForMalaysiaAirportsHoldingsBerhad",
//       formType: "richText",
//       label: "Body (EN)",
//       placeholder: "Enter the Risk Management Policy Statement",
//       validation: { required: "Risk Management Policy Statement is required" },
//     },
//     {
//       fieldName: "Next Page Name (EN)",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_name",
//       formType: "input",
//       label: "Next Page Name (EN)",
//       placeholder: "Enter content for Next Page Name (EN)",
//       validation: { required: "Content for Next Page Name (EN) is required" },
//     },
//     {
//       fieldName: "Next Page Link (EN)",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_link",
//       formType: "input",
//       label: "Next Page Link (EN)",
//       placeholder: "Enter content for Next Page Link (EN)",
//       validation: { required: "Content for Next Page Link (EN) is required" },
//     },

//     {
//       fieldName: "Markup (MS)",
//       fieldValue: "data.items[0].tabData.items[11].markup",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_riskManagementPolicyStatementForMalaysiaAirportsHoldingsBerhad",
//       formType: "richText",
//       label: "Body (MS)",
//       placeholder: "Enter the Risk Management Policy Statement",
//       // validation: { required: "Risk Management Policy Statement is required" },
//     },
//     {
//       fieldName: "Next Page Name (MS)",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_nextPage_name",
//       formType: "input",
//       label: "Next Page Name (MS)",
//       placeholder: "Enter content for Next Page Name (MS)",
//       // validation: { required: "Content for Next Page Name (MS) is required" },
//     },
//     {
//       fieldName: "Next Page Link (MS)",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_nextPage_link",
//       formType: "input",
//       label: "Next Page Link (MS)",
//       placeholder: "Enter content for Next Page Link (MS)",
//       // validation: { required: "Content for Next Page Link (MS) is required" },
//     },

//     {
//       fieldName: "Markup (ZH)",
//       fieldValue: "data.items[0].tabData.items[11].markup",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_riskManagementPolicyStatementForMalaysiaAirportsHoldingsBerhad",
//       formType: "richText",
//       label: "Body (ZH)",
//       placeholder: "Enter the Risk Management Policy Statement",
//       // validation: { required: "Risk Management Policy Statement is required" },
//     },
//     {
//       fieldName: "Next Page Name (ZH)",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_name",
//       formType: "input",
//       label: "Next Page Name (ZH)",
//       placeholder: "Enter content for Next Page Name (ZH)",
//       // validation: { required: "Content for Next Page Name (ZH) is required" },
//     },
//     {
//       fieldName: "Next Page Link (ZH)",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_link",
//       formType: "input",
//       label: "Next Page Link (ZH)",
//       placeholder: "Enter content for Next Page Link (ZH)",
//       // validation: { required: "Content for Next Page Link (ZH) is required" },
//     },
//   ],

//   occupationalHealthAndSafetyPolicyForMalaysiaAirportsHoldingsBerhad: [
//     {
//       fieldName: "Markup (EN)",
//       fieldValue: "data.items[0].tabData.items[12].markup",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_occupationalHealthAndSafetyPolicyForMalaysiaAirportsHoldingsBerhad",
//       formType: "richText",
//       label: "Body (EN)",
//       placeholder: "Enter the Occupational Health And Safety Policy",
//       validation: { required: "Occupational Health And Safety Policy is required" },
//     },
//     {
//       fieldName: "Next Page Name (EN)",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_name",
//       formType: "input",
//       label: "Next Page Name (EN)",
//       placeholder: "Enter content for Next Page Name (EN)",
//       validation: { required: "Content for Next Page Name (EN) is required" },
//     },
//     {
//       fieldName: "Next Page Link (EN)",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_link",
//       formType: "input",
//       label: "Next Page Link (EN)",
//       placeholder: "Enter content for Next Page Link (EN)",
//       validation: { required: "Content for Next Page Link (EN) is required" },
//     },

//     {
//       fieldName: "Markup (MS)",
//       fieldValue: "data.items[0].tabData.items[12].markup",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_occupationalHealthAndSafetyPolicyForMalaysiaAirportsHoldingsBerhad",
//       formType: "richText",
//       label: "Body (MS)",
//       placeholder: "Enter the Occupational Health And Safety Policy",
//       // validation: { required: "Occupational Health And Safety Policy is required" },
//     },
//     {
//       fieldName: "Next Page Name (MS)",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_nextPage_name",
//       formType: "input",
//       label: "Next Page Name (MS)",
//       placeholder: "Enter content for Next Page Name (MS)",
//       // validation: { required: "Content for Next Page Name (MS) is required" },
//     },
//     {
//       fieldName: "Next Page Link (MS)",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_nextPage_link",
//       formType: "input",
//       label: "Next Page Link (MS)",
//       placeholder: "Enter content for Next Page Link (MS)",
//       // validation: { required: "Content for Next Page Link (MS) is required" },
//     },

//     {
//       fieldName: "Markup (ZH)",
//       fieldValue: "data.items[0].tabData.items[12].markup",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_occupationalHealthAndSafetyPolicyForMalaysiaAirportsHoldingsBerhad",
//       formType: "richText",
//       label: "Body (ZH)",
//       placeholder: "Enter the Occupational Health And Safety Policy",
//       // validation: { required: "Occupational Health And Safety Policy is required" },
//     },
//     {
//       fieldName: "Next Page Name (ZH)",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_name",
//       formType: "input",
//       label: "Next Page Name (ZH)",
//       placeholder: "Enter content for Next Page Name (ZH)",
//       // validation: { required: "Content for Next Page Name (ZH) is required" },
//     },
//     {
//       fieldName: "Next Page Link (ZH)",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_link",
//       formType: "input",
//       label: "Next Page Link (ZH)",
//       placeholder: "Enter content for Next Page Link (ZH)",
//       // validation: { required: "Content for Next Page Link (ZH) is required" },
//     },
//   ],

//   sexualHarassmentPolicyForMalaysiaAirportsHoldingsBerhad: [
//     {
//       fieldName: "Markup (EN)",
//       fieldValue: "data.items[0].tabData.items[13].markup",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_sexualHarassmentPolicyForMalaysiaAirportsHoldingsBerhad",
//       formType: "richText",
//       label: "Body (EN)",
//       placeholder: "Enter the Sexual Harassment Policy",
//       validation: { required: "Sexual Harassment Policy is required" },
//     },
//     {
//       fieldName: "Next Page Name (EN)",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_name",
//       formType: "input",
//       label: "Next Page Name (EN)",
//       placeholder: "Enter content for Next Page Name (EN)",
//       validation: { required: "Content for Next Page Name (EN) is required" },
//     },
//     {
//       fieldName: "Next Page Link (EN)",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_link",
//       formType: "input",
//       label: "Next Page Link (EN)",
//       placeholder: "Enter content for Next Page Link (EN)",
//       validation: { required: "Content for Next Page Link (EN) is required" },
//     },

//     {
//       fieldName: "Markup (MS)",
//       fieldValue: "data.items[0].tabData.items[13].markup",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_sexualHarassmentPolicyForMalaysiaAirportsHoldingsBerhad",
//       formType: "richText",
//       label: "Body (MS)",
//       placeholder: "Enter the Sexual Harassment Policy",
//       // validation: { required: "Sexual Harassment Policy is required" },
//     },
//     {
//       fieldName: "Next Page Name (MS)",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_nextPage_name",
//       formType: "input",
//       label: "Next Page Name (MS)",
//       placeholder: "Enter content for Next Page Name (MS)",
//       // validation: { required: "Content for Next Page Name (MS) is required" },
//     },
//     {
//       fieldName: "Next Page Link (MS)",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_nextPage_link",
//       formType: "input",
//       label: "Next Page Link (MS)",
//       placeholder: "Enter content for Next Page Link (MS)",
//       // validation: { required: "Content for Next Page Link (MS) is required" },
//     },

//     {
//       fieldName: "Markup (ZH)",
//       fieldValue: "data.items[0].tabData.items[13].markup",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_sexualHarassmentPolicyForMalaysiaAirportsHoldingsBerhad",
//       formType: "richText",
//       label: "Body (ZH)",
//       placeholder: "Enter the Sexual Harassment Policy",
//       // validation: { required: "Sexual Harassment Policy is required" },
//     },
//     {
//       fieldName: "Next Page Name (ZH)",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_name",
//       formType: "input",
//       label: "Next Page Name (ZH)",
//       placeholder: "Enter content for Next Page Name (ZH)",
//       // validation: { required: "Content for Next Page Name (ZH) is required" },
//     },
//     {
//       fieldName: "Next Page Link (ZH)",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_link",
//       formType: "input",
//       label: "Next Page Link (ZH)",
//       placeholder: "Enter content for Next Page Link (ZH)",
//       // validation: { required: "Content for Next Page Link (ZH) is required" },
//     },
//   ],

//   stopWorkPolicyForMalaysiaAirportsHoldingsBerhad: [
//     {
//       fieldName: "Markup (EN)",
//       fieldValue: "data.items[0].tabData.items[14].markup",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_stopWorkPolicyForMalaysiaAirportsHoldingsBerhad",
//       formType: "richText",
//       label: "Body (EN)",
//       placeholder: "Enter the Stop - Work Policy",
//       validation: { required: "Stop - Work Policy is required" },
//     },
//     {
//       fieldName: "Next Page Name (EN)",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_name",
//       formType: "input",
//       label: "Next Page Name (EN)",
//       placeholder: "Enter content for Next Page Name (EN)",
//       validation: { required: "Content for Next Page Name (EN) is required" },
//     },
//     {
//       fieldName: "Next Page Link (EN)",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_link",
//       formType: "input",
//       label: "Next Page Link (EN)",
//       placeholder: "Enter content for Next Page Link (EN)",
//       validation: { required: "Content for Next Page Link (EN) is required" },
//     },

//     {
//       fieldName: "Markup (MS)",
//       fieldValue: "data.items[0].tabData.items[14].markup",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_stopWorkPolicyForMalaysiaAirportsHoldingsBerhad",
//       formType: "richText",
//       label: "Body (MS)",
//       placeholder: "Enter the Stop - Work Policy",
//       // validation: { required: "Stop - Work Policy is required" },
//     },
//     {
//       fieldName: "Next Page Name (MS)",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_nextPage_name",
//       formType: "input",
//       label: "Next Page Name (MS)",
//       placeholder: "Enter content for Next Page Name (MS)",
//       // validation: { required: "Content for Next Page Name (MS) is required" },
//     },
//     {
//       fieldName: "Next Page Link (MS)",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_nextPage_link",
//       formType: "input",
//       label: "Next Page Link (MS)",
//       placeholder: "Enter content for Next Page Link (MS)",
//       // validation: { required: "Content for Next Page Link (MS) is required" },
//     },

//     {
//       fieldName: "Markup (ZH)",
//       fieldValue: "data.items[0].tabData.items[14].markup",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_stopWorkPolicyForMalaysiaAirportsHoldingsBerhad",
//       formType: "richText",
//       label: "Body (ZH)",
//       placeholder: "Enter the Stop - Work Policy",
//       // validation: { required: "Stop - Work Policy is required" },
//     },
//     {
//       fieldName: "Next Page Name (ZH)",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_name",
//       formType: "input",
//       label: "Next Page Name (ZH)",
//       placeholder: "Enter content for Next Page Name (ZH)",
//       // validation: { required: "Content for Next Page Name (ZH) is required" },
//     },
//     {
//       fieldName: "Next Page Link (ZH)",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_link",
//       formType: "input",
//       label: "Next Page Link (ZH)",
//       placeholder: "Enter content for Next Page Link (ZH)",
//       // validation: { required: "Content for Next Page Link (ZH) is required" },
//     },
//   ],

//   antiBriberyAndCorruptionPolicyStatementForMalaysiaAirportsHoldingsBerhad: [
//     {
//       fieldName: "Markup (EN)",
//       fieldValue: "data.items[0].tabData.items[15].markup",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_antiBriberyAndCorruptionPolicyStatementForMalaysiaAirportsHoldingsBerhad",
//       formType: "richText",
//       label: "Body (EN)",
//       placeholder: "Enter the Anti-Bribery and Corruption Policy Statement",
//       validation: { required: "Anti-Bribery and Corruption Policy Statement is required" },
//     },
//     {
//       fieldName: "Next Page Name (EN)",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_name",
//       formType: "input",
//       label: "Next Page Name (EN)",
//       placeholder: "Enter content for Next Page Name (EN)",
//       validation: { required: "Content for Next Page Name (EN) is required" },
//     },
//     {
//       fieldName: "Next Page Link (EN)",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_link",
//       formType: "input",
//       label: "Next Page Link (EN)",
//       placeholder: "Enter content for Next Page Link (EN)",
//       validation: { required: "Content for Next Page Link (EN) is required" },
//     },

//     {
//       fieldName: "Markup (MS)",
//       fieldValue: "data.items[0].tabData.items[15].markup",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_antiBriberyAndCorruptionPolicyStatementForMalaysiaAirportsHoldingsBerhad",
//       formType: "richText",
//       label: "Body (MS)",
//       placeholder: "Enter the Anti-Bribery and Corruption Policy Statement",
//       // validation: { required: "Anti-Bribery and Corruption Policy Statement is required" },
//     },
//     {
//       fieldName: "Next Page Name (MS)",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_nextPage_name",
//       formType: "input",
//       label: "Next Page Name (MS)",
//       placeholder: "Enter content for Next Page Name (MS)",
//       // validation: { required: "Content for Next Page Name (MS) is required" },
//     },
//     {
//       fieldName: "Next Page Link (MS)",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_nextPage_link",
//       formType: "input",
//       label: "Next Page Link (MS)",
//       placeholder: "Enter content for Next Page Link (MS)",
//       // validation: { required: "Content for Next Page Link (MS) is required" },
//     },

//     {
//       fieldName: "Markup (ZH)",
//       fieldValue: "data.items[0].tabData.items[15].markup",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_antiBriberyAndCorruptionPolicyStatementForMalaysiaAirportsHoldingsBerhad",
//       formType: "richText",
//       label: "Body (ZH)",
//       placeholder: "Enter the Anti-Bribery and Corruption Policy Statement",
//       // validation: { required: "Anti-Bribery and Corruption Policy Statement is required" },
//     },
//     {
//       fieldName: "Next Page Name (ZH)",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_name",
//       formType: "input",
//       label: "Next Page Name (ZH)",
//       placeholder: "Enter content for Next Page Name (ZH)",
//       // validation: { required: "Content for Next Page Name (ZH) is required" },
//     },
//     {
//       fieldName: "Next Page Link (ZH)",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_link",
//       formType: "input",
//       label: "Next Page Link (ZH)",
//       placeholder: "Enter content for Next Page Link (ZH)",
//       // validation: { required: "Content for Next Page Link (ZH) is required" },
//     },
//   ],

//   sustainabilityPolicyForMalaysiaAirportsHoldingsBerhad: [
//     {
//       fieldName: "Markup (EN)",
//       fieldValue: "data.items[0].tabData.items[16].markup",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_sustainabilityPolicyForMalaysiaAirportsHoldingsBerhad",
//       formType: "richText",
//       label: "Body (EN)",
//       placeholder: "Enter the Sustainability Policy",
//       validation: { required: "Sustainability Policy is required" },
//     },
//     {
//       fieldName: "Next Page Name (EN)",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_name",
//       formType: "input",
//       label: "Next Page Name (EN)",
//       placeholder: "Enter content for Next Page Name (EN)",
//       validation: { required: "Content for Next Page Name (EN) is required" },
//     },
//     {
//       fieldName: "Next Page Link (EN)",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_link",
//       formType: "input",
//       label: "Next Page Link (EN)",
//       placeholder: "Enter content for Next Page Link (EN)",
//       validation: { required: "Content for Next Page Link (EN) is required" },
//     },

//     {
//       fieldName: "Markup (MS)",
//       fieldValue: "data.items[0].tabData.items[16].markup",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_sustainabilityPolicyForMalaysiaAirportsHoldingsBerhad",
//       formType: "richText",
//       label: "Body (MS)",
//       placeholder: "Enter the Sustainability Policy",
//       // validation: { required: "Sustainability Policy is required" },
//     },
//     {
//       fieldName: "Next Page Name (MS)",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_nextPage_name",
//       formType: "input",
//       label: "Next Page Name (MS)",
//       placeholder: "Enter content for Next Page Name (MS)",
//       // validation: { required: "Content for Next Page Name (MS) is required" },
//     },
//     {
//       fieldName: "Next Page Link (MS)",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_nextPage_link",
//       formType: "input",
//       label: "Next Page Link (MS)",
//       placeholder: "Enter content for Next Page Link (MS)",
//       // validation: { required: "Content for Next Page Link (MS) is required" },
//     },

//     {
//       fieldName: "Markup (ZH)",
//       fieldValue: "data.items[0].tabData.items[16].markup",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_sustainabilityPolicyForMalaysiaAirportsHoldingsBerhad",
//       formType: "richText",
//       label: "Body (ZH)",
//       placeholder: "Enter the Sustainability Policy",
//       // validation: { required: "Sustainability Policy is required" },
//     },
//     {
//       fieldName: "Next Page Name (ZH)",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_name",
//       formType: "input",
//       label: "Next Page Name (ZH)",
//       placeholder: "Enter content for Next Page Name (ZH)",
//       // validation: { required: "Content for Next Page Name (ZH) is required" },
//     },
//     {
//       fieldName: "Next Page Link (ZH)",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_link",
//       formType: "input",
//       label: "Next Page Link (ZH)",
//       placeholder: "Enter content for Next Page Link (ZH)",
//       // validation: { required: "Content for Next Page Link (ZH) is required" },
//     },
//   ],

//   termsOfConditionsForMalaysiaAirportsHoldingsBerhad: [
//     {
//       fieldName: "Markup (EN)",
//       fieldValue: "data.items[0].tabData.items[17].markup",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_termsOfConditionsForMalaysiaAirportsHoldingsBerhad",
//       formType: "richText",
//       label: "Body (EN)",
//       placeholder: "Enter the Terms of Conditions",
//       validation: { required: "Terms of Conditions is required" },
//     },
//     {
//       fieldName: "Next Page Name (EN)",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_name",
//       formType: "input",
//       label: "Next Page Name (EN)",
//       placeholder: "Enter content for Next Page Name (EN)",
//       validation: { required: "Content for Next Page Name (EN) is required" },
//     },
//     {
//       fieldName: "Next Page Link (EN)",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_link",
//       formType: "input",
//       label: "Next Page Link (EN)",
//       placeholder: "Enter content for Next Page Link (EN)",
//       validation: { required: "Content for Next Page Link (EN) is required" },
//     },

//     {
//       fieldName: "Markup (MS)",
//       fieldValue: "data.items[0].tabData.items[17].markup",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_termsOfConditionsForMalaysiaAirportsHoldingsBerhad",
//       formType: "richText",
//       label: "Body (MS)",
//       placeholder: "Enter the Terms of Conditions",
//       // validation: { required: "Terms of Conditions is required" },
//     },
//     {
//       fieldName: "Next Page Name (MS)",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_nextPage_name",
//       formType: "input",
//       label: "Next Page Name (MS)",
//       placeholder: "Enter content for Next Page Name (MS)",
//       // validation: { required: "Content for Next Page Name (MS) is required" },
//     },
//     {
//       fieldName: "Next Page Link (MS)",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_nextPage_link",
//       formType: "input",
//       label: "Next Page Link (MS)",
//       placeholder: "Enter content for Next Page Link (MS)",
//       // validation: { required: "Content for Next Page Link (MS) is required" },
//     },

//     {
//       fieldName: "Markup (ZH)",
//       fieldValue: "data.items[0].tabData.items[17].markup",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_termsOfConditionsForMalaysiaAirportsHoldingsBerhad",
//       formType: "richText",
//       label: "Body (ZH)",
//       placeholder: "Enter the Terms of Conditions",
//       // validation: { required: "Terms of Conditions is required" },
//     },
//     {
//       fieldName: "Next Page Name (ZH)",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_name",
//       formType: "input",
//       label: "Next Page Name (ZH)",
//       placeholder: "Enter content for Next Page Name (ZH)",
//       // validation: { required: "Content for Next Page Name (ZH) is required" },
//     },
//     {
//       fieldName: "Next Page Link (ZH)",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_link",
//       formType: "input",
//       label: "Next Page Link (ZH)",
//       placeholder: "Enter content for Next Page Link (ZH)",
//       // validation: { required: "Content for Next Page Link (ZH) is required" },
//     },
//   ],

//   codeOfEthicsForSubsidiaries: [
//     {
//       fieldName: "Markup (EN)",
//       fieldValue: "data.items[1].tabData.items[0].markup",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_codeOfEthicsForSubsidiaries",
//       formType: "richText",
//       label: "Body (EN)",
//       placeholder: "Enter the Code of Ethics",
//       validation: { required: "Code of Ethics is required" },
//     },
//     {
//       fieldName: "Next Page Name (EN)",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_name",
//       formType: "input",
//       label: "Next Page Name (EN)",
//       placeholder: "Enter content for Next Page Name (EN)",
//       validation: { required: "Content for Next Page Name (EN) is required" },
//     },
//     {
//       fieldName: "Next Page Link (EN)",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_link",
//       formType: "input",
//       label: "Next Page Link (EN)",
//       placeholder: "Enter content for Next Page Link (EN)",
//       validation: { required: "Content for Next Page Link (EN) is required" },
//     },

//     {
//       fieldName: "Markup (MS)",
//       fieldValue: "data.items[1].tabData.items[0].markup",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_codeOfEthicsForSubsidiaries",
//       formType: "richText",
//       label: "Body (MS)",
//       placeholder: "Enter the Code of Ethics",
//       // validation: { required: "Code of Ethics is required" },
//     },
//     {
//       fieldName: "Next Page Name (MS)",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_nextPage_name",
//       formType: "input",
//       label: "Next Page Name (MS)",
//       placeholder: "Enter content for Next Page Name (MS)",
//       // validation: { required: "Content for Next Page Name (MS) is required" },
//     },
//     {
//       fieldName: "Next Page Link (MS)",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_nextPage_link",
//       formType: "input",
//       label: "Next Page Link (MS)",
//       placeholder: "Enter content for Next Page Link (MS)",
//       // validation: { required: "Content for Next Page Link (MS) is required" },
//     },

//     {
//       fieldName: "Markup (ZH)",
//       fieldValue: "data.items[1].tabData.items[0].markup",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_codeOfEthicsForSubsidiaries",
//       formType: "richText",
//       label: "Body (ZH)",
//       placeholder: "Enter the Code of Ethics",
//       // validation: { required: "Code of Ethics is required" },
//     },
//     {
//       fieldName: "Next Page Name (ZH)",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_name",
//       formType: "input",
//       label: "Next Page Name (ZH)",
//       placeholder: "Enter content for Next Page Name (ZH)",
//       // validation: { required: "Content for Next Page Name (ZH) is required" },
//     },
//     {
//       fieldName: "Next Page Link (ZH)",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_link",
//       formType: "input",
//       label: "Next Page Link (ZH)",
//       placeholder: "Enter content for Next Page Link (ZH)",
//       // validation: { required: "Content for Next Page Link (ZH) is required" },
//     },
//   ],

//   conditionsOfUseForSubsidiaries: [
//     {
//       fieldName: "Markup (EN)",
//       fieldValue: "data.items[1].tabData.items[1].markup",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_conditionsOfUseForSubsidiaries",
//       formType: "richText",
//       label: "Body (EN)",
//       placeholder: "Enter the Conditions of Use",
//       validation: { required: "Conditions of Use is required" },
//     },
//     {
//       fieldName: "Next Page Name (EN)",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_name",
//       formType: "input",
//       label: "Next Page Name (EN)",
//       placeholder: "Enter content for Next Page Name (EN)",
//       validation: { required: "Content for Next Page Name (EN) is required" },
//     },
//     {
//       fieldName: "Next Page Link (EN)",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_link",
//       formType: "input",
//       label: "Next Page Link (EN)",
//       placeholder: "Enter content for Next Page Link (EN)",
//       validation: { required: "Content for Next Page Link (EN) is required" },
//     },

//     {
//       fieldName: "Markup (MS)",
//       fieldValue: "data.items[1].tabData.items[1].markup",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_conditionsOfUseForSubsidiaries",
//       formType: "richText",
//       label: "Body (MS)",
//       placeholder: "Enter the Conditions of Use",
//       // validation: { required: "Conditions of Use is required" },
//     },
//     {
//       fieldName: "Next Page Name (MS)",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_nextPage_name",
//       formType: "input",
//       label: "Next Page Name (MS)",
//       placeholder: "Enter content for Next Page Name (MS)",
//       // validation: { required: "Content for Next Page Name (MS) is required" },
//     },
//     {
//       fieldName: "Next Page Link (MS)",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_malay",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_malay_nextPage_link",
//       formType: "input",
//       label: "Next Page Link (MS)",
//       placeholder: "Enter content for Next Page Link (MS)",
//       // validation: { required: "Content for Next Page Link (MS) is required" },
//     },

//     {
//       fieldName: "Markup (ZH)",
//       fieldValue: "data.items[1].tabData.items[1].markup",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_conditionsOfUseForSubsidiaries",
//       formType: "richText",
//       label: "Body (ZH)",
//       placeholder: "Enter the Conditions of Use",
//       // validation: { required: "Conditions of Use is required" },
//     },
//     {
//       fieldName: "Next Page Name (ZH)",
//       fieldValue: "data.nextPage.name",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_name",
//       formType: "input",
//       label: "Next Page Name (ZH)",
//       placeholder: "Enter content for Next Page Name (ZH)",
//       // validation: { required: "Content for Next Page Name (ZH) is required" },
//     },
//     {
//       fieldName: "Next Page Link (ZH)",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_mandarin",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_mandarin_nextPage_link",
//       formType: "input",
//       label: "Next Page Link (ZH)",
//       placeholder: "Enter content for Next Page Link (ZH)",
//       // validation: { required: "Content for Next Page Link (ZH) is required" },
//     },
//   ],
// };
